import { useQuery } from '@tanstack/react-query';

import { AuthorizationRequestType, SafetyEventReport, ProblemDetails, SafetyEventClient } from '../../clients';
import queryKeys from '../../queryKeys';
import { apiBaseUrl } from '../../../config';

const safetyEventClient = new SafetyEventClient(apiBaseUrl);

function useGetSafetyEventReport(id: number, role: AuthorizationRequestType) {
  return useQuery<SafetyEventReport, ProblemDetails>({
    queryKey: [queryKeys.SafetyEvent.Get, { id }],
    queryFn: () => safetyEventClient.get(id, role),
    refetchInterval: false,
    refetchIntervalInBackground: false,
    refetchOnReconnect: false,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
  });
}

export default useGetSafetyEventReport;
